import {forkJoin as observableForkJoin, of as observableOf, from as observableFrom, interval as observableInterval,  Observable ,  Subscription ,  BehaviorSubject } from 'rxjs';

import {debounceTime, mergeMap, concatMap, map, distinctUntilChanged, catchError} from 'rxjs/operators';
import { Component, OnInit, OnDestroy, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, Input, } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core'; // tslint:disable-line
import { INode, NodeType } from './INode';
import { AbstractControl, FormGroup, FormArray, FormControl } from '@angular/forms';
import { IAttribute } from '../attribute/IAttribute';
import { Attribute } from '../attribute/Attribute';
import { IAction } from '../action/IAction';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { LoggerService } from '../logger-service/logger.service';
import { DialogService } from '../confirm-dialog/dialog.service';
import { ErrorNotificationService } from '../error/error-notification.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from "../storage-service/storage.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import * as moment from 'moment';
import { DialogExportService } from "../confirm-dialog-export/export-dialog-service";
import { ApplicationService } from "../application-service/application.service";
import { EventLogModel } from "../config-eventlogs/eventlog-model";
import { SelectDialogExportService } from "../select-dialog-export/select-dialog-export-service";
import { ConfigSearchService } from '../config-breadcrumb/config-search/config-search.service';
@Component({
    selector: 'wbm-config-detail',
    templateUrl: './config-detail.component.html',
    styleUrls: ['../../assets/theme/css/ConfigDetail.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigDetailComponent implements OnInit, OnDestroy {
    @HostBinding() class = 'home-box flex-item-fluid flex-container-v nowrap relativeto mw45 mam mls ';

    @Input() public rootNode1: INode;

    @Output()
    valueChange: EventEmitter<any> = new EventEmitter<any>();
    private showbuzy: boolean;
    public finalData: any = {};
    public node: INode;
    private numberOfNodes: number = 0;
    public selectedGroupId: number = null;
    public nodeForm: FormGroup;
    private nodeType = NodeType; // tslint:disable-line
    public actionWithInfo = null;
    private _protocol: string = window.location.protocol;
    private _baseApi: string = '/api/mgt/1.0';
    private subscriptions: Array<Subscription> = [];
    jsonObj: JSON;
    csvData: Array<string>[] = [];
    url: string;
    translations: Array<string> = ["creation-of", "updation-of", "deletion-of", "successfull", "failed"];
    translatedvalues: Array<string>[] = [];
    massProLogArray: Array<EventLogModel>;
    newData: Array<string> = [];
    selectedSubClassNames: Array<Object> = [];
    seqHeaderArray: string[] = [];
    seqValueArray: string[] = [];
    private _loaderSubject: BehaviorSubject<boolean>;
    loaderObserver: Observable<boolean>;
    logarray: Array<Object>;
    logArrayImport: Array<Object> = [];
    isJsonEmpty = true;
    attrs = [];
    allAttrs = [];
    showSearchResult = false;

    public static getAttributeControls(node: INode, attribute: IAttribute, disabled: boolean, cd: ChangeDetectorRef) {
        let fc: AbstractControl;
        let controls;
        let value = attribute.localValue === undefined ? attribute.value : attribute.localValue;

        if (attribute.isSetOf) {
            controls = [];
            //insert controls for values
            if (attribute.value) {
                for (let index = 0; index < attribute.value.length; index++) {
                    controls.push(ConfigDetailComponent.getAttributeControls(node, attribute.value[index], disabled, cd));
                }
            }
            fc = new FormArray(controls);
        } else if (attribute.isSequence) {
            controls = {};
            if (attribute.value) {
                for (let key in attribute.value) {
                    if (attribute.value.hasOwnProperty(key)) {
                        let subAttr = attribute.value[key];
                        controls[subAttr.name] = ConfigDetailComponent.getAttributeControls(node, subAttr, disabled, cd);
                    }
                }
            }
            fc = new FormGroup(controls);
        } else if (attribute.isByteString) {
            controls = {};
            let setOfVal = attribute.value;
            if (setOfVal) {
                let index = 0;
                for (let key in setOfVal) {
                    if (setOfVal.hasOwnProperty(key)) {
                        let subAttr = setOfVal[key];
                        // special reaffectation case to avoid crash when control's key becomes an integer after modification
                        if (attribute.localValue !== undefined && attribute.localValue.hasOwnProperty(index)) {
                            subAttr = attribute.localValue[index];
                        }
                        // case Byte_String (no property value)
                        controls[key] = new FormControl({ value: subAttr, disabled });
                        index++;
                    }
                }
            }
            fc = new FormGroup(controls);
            if (attribute.localValue !== undefined) {
                fc.markAsDirty();
            }

        } else if (attribute.isOctetString && attribute.structure['type'] && attribute.structure['type'].pattern) {
            if (attribute.isUtf8) {
                fc = new FormControl({ value, disabled }, [ConfigDetailComponent.createPatternValidator(attribute, node.isLocal), ConfigDetailComponent.createUTF8Validator(attribute, node.isLocal), ConfigDetailComponent.createRequiredValidator(attribute, node.isLocal)]);
            } else {
                fc = new FormControl({ value, disabled }, [ConfigDetailComponent.createPatternValidator(attribute, node.isLocal), ConfigDetailComponent.createLatin1Validator(attribute, node.isLocal), ConfigDetailComponent.createRequiredValidator(attribute, node.isLocal)]);
            }

            if (attribute.localValue !== undefined) {
                fc.markAsDirty();
            }
        } else if (attribute.isInteger && attribute.structure['type'] && attribute.structure['type'].values) {
            fc = new FormControl({ value, disabled }, ConfigDetailComponent.createIntegerValidator(attribute, node.isLocal));
            if (attribute.localValue !== undefined) {
                fc.markAsDirty();
            }
        } else if (attribute.isBoolean) {
            fc = new FormControl({ value, disabled });
            if (attribute.localValue !== undefined) {
                fc.markAsDirty();
            }
        } else {
            fc = new FormControl({ value, disabled });
            if (attribute.localValue !== undefined) {
                fc.markAsDirty();
            }
        }

        fc.valueChanges.pipe(distinctUntilChanged()).subscribe((newvalue) => {

            if (attribute.isByteString) {
                attribute.localValue = Object.keys(newvalue).map(key => newvalue[key]).join('');
            } else {
                attribute.localValue = newvalue;
            }

            // Check validity of attribute and validate the node
            attribute.evaluateValidity();
            node.evaluateAttributesUsedWhen();
            node.evaluateSubNodesUsedWhen();

            node.computeValidity();

            if (!attribute.hasValueChanged()) {
                attribute.clearLocalChanges();
                fc.markAsPristine();
            }
            if (cd) {
                cd.markForCheck();
            }
        });

        return fc;
    }

    static createRequiredValidator(attribute: IAttribute, isLocal: boolean) {
        return (c: FormControl) => {
            // a value coming from the server should always be considered as valid, even when not respecting the constraints
            // so do not validate if not dirty and not local (ie. not creation mode)
            return (!c.dirty && !isLocal) || !attribute.isUsed || attribute.isOptional || c.value === undefined || !Attribute.isEmpty(c.value) ? null : {
                validateRequired: {
                    valid: false
                }
            };
        };
    }

    static createPatternValidator(attribute: IAttribute, isLocal: boolean) {
        return (c: FormControl) => {
            let regex = attribute.getConstraints() as RegExp;
            // a value coming from the server should always be considered as valid, even when not respecting the constraints
            // so do not validate if not dirty and not local (ie. not creation mode)
            return (!c.dirty && !isLocal) || !attribute.isUsed || !regex || c.value === undefined || regex.test(c.value) ? null : {
                validatePattern: {
                    valid: false
                }
            };
        };
    }

    static createIntegerValidator(attribute: IAttribute, isLocal: boolean) {
        return (c: FormControl) => {
            let constraintsLogic = attribute.getConstraints();
            // a value coming from the server should always be considered as valid, even when not respecting the constraints
            // so do not validate if not dirty and not local (ie. not creation mode)
            return (!c.dirty && !isLocal) || !attribute.isUsed || c.value === undefined || jsonLogic.apply(constraintsLogic, { 'attrValue': c.value }) ? null : {
                validateInteger: {
                    valid: false
                }
            };
        };
    }

    static createUTF8Validator(attribute: IAttribute, isLocal: boolean) {
        return (c: FormControl) => {
            let pattern: string = attribute.structure['type'].pattern;
            let maxLength = Attribute.getMaxLength(pattern);
            // a value coming from the server should always be considered as valid, even when not respecting the constraints
            // so do not validate if not dirty and not local (ie. not creation mode)
            return (!c.dirty && !isLocal) || !attribute.isUsed || !maxLength || c.value === undefined || Attribute.countUtf8Bytes(c.value) <= maxLength ? null : {
                validateUTF8: {
                    valid: false
                }
            };
        };
    }

    static createLatin1Validator(attribute: IAttribute, isLocal: boolean) {
        return (c: FormControl) => {
            // a value coming from the server should always be considered as valid, even when not respecting the constraints
            // so do not validate if not dirty and not local (ie. not creation mode)
            return (!c.dirty && !isLocal) || !attribute.isUsed || c.value === undefined || Attribute.isLatin1(c.value) ? null : {
                validateLatin1: {
                    valid: false
                }
            };
        };
    }

    constructor(
        private _notification: NotificationsService,
        private _oxeModel: OxeModelService,
        private _logger: LoggerService,
        private _dialogService: DialogService,
        private _translate: TranslateService,
        private _errorNotification: ErrorNotificationService,
        private cd: ChangeDetectorRef,
        private _storage: StorageService,
        private http: HttpClient,
        private _dialogExportService: DialogExportService,
        private _appliservice: ApplicationService,
        private _selectExportService: SelectDialogExportService,
        private _searchService: ConfigSearchService
    ) {
        this._loaderSubject = new BehaviorSubject(true);
        this.loaderObserver = this._loaderSubject.asObservable().pipe(
            distinctUntilChanged()),
            debounceTime(300);
    }



    ngOnInit() {
        this._appliservice.loadVersion();
        this._translate.get(this.translations)
            .subscribe((translatedString) => {
                this.translatedvalues = translatedString;
            })
        this.subscriptions.push(this._oxeModel.selectedNodeObserver.pipe(
            map(node => {
                if (node && node.isOneInstance && node.isClassNode) {
                    if (node.subNodes && node.subNodes.length > 0) {
                        return node.subNodes[0];
                    } else {
                        this._logger.error('ConfigurationComponent', 'Node ' + node.name + ' Inconsistent OneInstance class without subnodes : error in OXE Rest API response?');
                        this._errorNotification.generateErrorNotification(new Error('Data inconsistency'), "InConsistent Data", ' ' + this.node.parent.name + ' ' + this.node.name + ' ');
                        return undefined;
                    }
                }
                return node;
            }),
            map(node => {
                if (node && node.structure && node.structure.hasOwnProperty('attributeGroups') && node.structure['attributeGroups'].length > 0) {
                    // PATCH: Add fake group Other for ungrouped attributes
                    let attributesWithoutGroup = node.attributes.filter((attr: IAttribute) => {
                        return !node.structure['attributeGroups'].find(group => {
                            return group.attributes.indexOf(attr.name) !== -1;
                        });
                    })
                        .map((attr: IAttribute) => attr.name);

                    if (attributesWithoutGroup.length > 0) {
                        node.structure['attributeGroups'].push({ attributes: attributesWithoutGroup, name: 'other' });
                    }

                    // Select the group who contains the node id
                    if (this.selectedGroupId !== null && node.parent === this.node.parent) {
                        this.selectedGroupId = this.selectedGroupId % node.structure['attributeGroups'].length;
                    } else {
                        this.selectedGroupId = node.isOneInstance ? 0 : node.structure['attributeGroups'].findIndex(group => group.attributes.indexOf(node.structure['id']) !== -1);
                    }
                } else {
                    this.selectedGroupId = null;
                }

                return node;
            }),)
            .subscribe(this.updateConfigDetails.bind(this)));

        this._searchService.showSearchChanges()
            .subscribe((data) => {
                this.cd.markForCheck();
            })
    }

    ngOnDestroy() {
        //release global subscriptions
        this.removeGlobalSubscriptions();
    }

    private removeGlobalSubscriptions() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }

    public isSearchResult(){
        return true;
    }

    public toSearchResults() {
        console.log("++ConfigDetailComponent::toSearchResults()");
        this._searchService.showSearch = true;
    }

    public updateConfigDetails(node: INode) {
        if (node) {
            this.node = node;
            this.actionWithInfo = undefined;
            this.updateFormControls();
            this.cd.markForCheck();
        }
    }

    private updateFormControls() {
        if (this.node) {
            // we will initialize our form here
            let attributeControls = {};
            this.node.attributes.filter((attr: IAttribute) => {
                // When the 'mask' field is true, it indicates that the attribute and its value shall be displayed at all, no control is needed
                return !attr.isMask && (this.selectedGroupId == null || this.node.structure['attributeGroups'][this.selectedGroupId].attributes.indexOf(attr.name) !== -1);
            })
                .forEach((attr: IAttribute) => {
                    // Note : the control is created here even for a not-creatable attribute of a local node, because it will be used after the local node submit (when it becomes not local)
                    let disabled: boolean = (!attr.isSettable && !this.node.isLocal) || (!attr.isCreatable && this.node.isLocal);
                    attributeControls[attr.name] = ConfigDetailComponent.getAttributeControls(this.node, attr, disabled, this.cd);
                });

            this.nodeForm = new FormGroup(attributeControls);
        }
    }

    getModifiedNodes(node: INode): Array<INode> {
        let parentNode = node;
        let modifiedNodes: Array<INode> = [];
        if (!this.node.isClassNode) {
            parentNode = node.parent;
        }
        if (parentNode !== undefined) {
            let subNodes = parentNode.getSubNodes();
            if (subNodes != undefined) {
                for (let k = 0; k < subNodes.length; k++) {
                    if (subNodes[k].isAttributesModified) {
                        modifiedNodes.push(subNodes[k]);
                    }
                    /* else
                        break; */
                }
            }
        }
        return modifiedNodes;
    }

    isSaveAllEnabled(): boolean {
        if (this.node === undefined) {
            return false;
        }
        let modifiedNodes1 = this.getModifiedNodes(this.node);
        if (modifiedNodes1.length > 0) {
            return true;
        } else {
            return false;
        }

    }

    getModifiedParentNodes(node: INode): Array<INode> {
        let modifiedParentNode: Array<INode> = [];
        let parentNode = node.parent;
        if (parentNode !== undefined) {
            if (parentNode.isAttributesModified) {
                modifiedParentNode.push(parentNode);
            }
            return modifiedParentNode.concat(this.getModifiedParentNodes(parentNode));
        }
        return modifiedParentNode;
    }

    SaveAll() {
        let operationType;
        if ((this.node.isValid /* && (this.node.isLocal || this.node.isAttributesModified) */) || this.node.isClassNode) {

            let modifiedNodes = this.getModifiedNodes(this.node);
            if (modifiedNodes.length != 0) {
                this._dialogService.confirm('confirm-save-all')
                    .then(() => {
                        let numberOfNodeSaved = 0;
                        let numberOfNodesProcessed = 0;
                        //let workingNode: INode;
                       observableFrom(modifiedNodes).pipe(
                            concatMap(node => this._oxeModel.setData(node, node.getLocalData(node.attributes)).pipe(
                                //.catch(error => Observable.of())
                                catchError((error) => {
                                    numberOfNodesProcessed++;
                                    this.valueChange.emit(Math.round((numberOfNodesProcessed * 100) / modifiedNodes.length));
                                    this._oxeModel.selectNode(node);
                                    if (this.node.isLocal) {
                                        operationType = this.translatedvalues['creation-of'];
                                        /* this._logger.storeLogArray('Error', this.translatedvalues['creation-of'] + ' ' + this.node.parent.name + ' '
                                            + this.node.name + ' ' + this.translatedvalues['failed']); */
                                    } else { 
                                        operationType = this.translatedvalues['updation-of'];
                                        /* this._logger.storeLogArray('Error', this.translatedvalues['updation-of'] + ' ' + this.node.parent.name + ' '
                                            + this.node.name + ' ' + this.translatedvalues['failed']); */
                                    }
                                    this._errorNotification.generateErrorNotification(error, operationType, ' ' + this.node.parent.name + ' ' + this.node.name + ' ' + this.translatedvalues['failed'], true);
                                    node.setValidity(false);
                                    console.log(error);
                                    return observableOf();
                                })
                            )
                            ))
                            .subscribe(
                            () => {
                                this.numberOfNodes--;
                                numberOfNodeSaved++;
                                numberOfNodesProcessed++;
                                if (this.node.isLocal) {
                                    this._logger.storeLogArray('Info', this.translatedvalues['creation-of'] + ' ' + this.node.parent.name + ' '
                                        + this.node.name + ' ' + this.translatedvalues['successfull']);
                                } else {
                                    this._logger.storeLogArray('Info', this.translatedvalues['updation-of'] + ' ' + this.node.parent.name + ' '
                                        + this.node.name + ' ' + this.translatedvalues['successfull']);
                                }
                                this.valueChange.emit(Math.round((numberOfNodesProcessed * 100) / modifiedNodes.length));
                                if (this._oxeModel.isProfiledUser(this.node)) {
                                    this.node.parent.subNodes.splice(this.node.parent.subNodes.indexOf(this.node), 1);
                                    this.node.parent.subNodesInitialLength--;
                                    //this._oxeModel.selectNode(this.node.parent);
                                }
                            },
                            (error) => {
                                numberOfNodesProcessed++;
                                this.valueChange.emit(Math.round((numberOfNodesProcessed * 100) / modifiedNodes.length));
                            },
                            () => {
                                this._translate.get('save-success')
                                    .subscribe((translatedString) => {
                                        this.notifySuccess(translatedString + '<br>' + numberOfNodeSaved + '/' + modifiedNodes.length);
                                        this.valueChange.emit("");
                                    });
                                this.numberOfNodes = 0;
                            }
                            );
                    })
                    .catch(() => { })
            }
            else {
                this.notifySuccess("No unsaved Nodes to Process");
            }
        } else {
            this.notifySuccess("nothing to save");
        }
    }

    getKeyByValue(object, value): string {
        let a = Object.keys(object).find(key => object[key] === value);
        if (a != undefined)
            return a;
        else
            return value;
    }

    filterJson(sourceObject, keys): Object {
        let newObject = {};
        keys.forEach(function (key) { newObject[key] = sourceObject[key]; });
        return newObject;
    }

    getNextLetter(char: string): string {
        let code: number = char.charCodeAt(0);
        code++;
        return String.fromCharCode(code);
    }

    isMassproEnabled(): boolean {
        if (this.node.name === "Subscriber")
            return true;
        else
            return false;
    }

    onImport(evt) {
        let subNodes;
        let attributes = {};
        this.logArrayImport.push("import Started");

        let filename = evt.target.files[0];
        let filetype = filename.name;
        let sFileExtension = filetype.split('.')[filetype.split('.').length - 1].toLowerCase();
        let filtered = {};
        let reader = new FileReader();
        let self = this;

        if (sFileExtension != "txt" && sFileExtension != "prg") {
            this._translate.get("unsupported-file-format")
            .subscribe((translatedMessage) => {
                this._notification.html(
                    `<aside class="flex-container nowrap flex-align-center notification notification--error icon__svg">
                    <span class="flex-item-fluid pas">` + translatedMessage + `</span>
                </aside>`, NotificationType.Bare, { timeOut: 0 });
                });

            return;
        }

        self._oxeModel.setLoader(true);
        this.logArrayImport.push("Reading File");
        self.valueChange.emit("Reading File...");
        try {
            reader.onloadend = function () {
                let classesinFile = [];
                //self._oxeModel.setLoader(true);
                let retrieveUserURL = self.node.getPath()/*  + "?attributes=Directory_Number,Entity_Number" */;//   "http://172.19.73.144/api/mgt/1.0/Node/121/Subscriber?attributes=Annu_Name,Annu_First_Name,UTF8_Phone_Book_Name,UTF8_Phone_Book_First_Name,Equipment_Address_Rack,Equipment_Address_Board,Equipme";
                self._oxeModel.getDataWithUrl(retrieveUserURL)
                    .subscribe((existingNodes) => {
                        self._oxeModel.setLoader(true);
                        // Last line of file comes as empty which need to be removed
                        let Lines = (<string>reader.result).split('\n');
                        if (Lines[Lines.length - 1] === "") {
                            Lines.pop();
                        }
                        let objData = {};
                        for (let i = 0; i < Lines.length; i++) {
                            let objectdata: any = [];
                            // skip any leading empty lines to be resilient to changed export formatting
                            while (i < Lines.length && (Lines[i] || '').trim() === "") {
                                i++;
                            }
                            if (i >= Lines.length) break;
                            let classname = (Lines[i] || '').trim();
                            let keysLine = (Lines[++i] || '');
                            let keys = keysLine.split('\t');
                            let dataValuesLine = (Lines[++i] || '');
                            let dataValues = dataValuesLine.split('\t');

                            if (classname === "Users" || classname === "Subscriber")                  //getting the classNames from dict in nonttranslation format
                                classname = "Subscriber";
                            else {
                                classname = self.getKeyByValue(self._appliservice.dict, classname.trim());
                            }
                            if (classname === "RemoteExtension") {
                                classname = "Remote_Extension";
                            }

                            /* if (sFileExtension === "txt")
                                for (let jk = 0; jk < keys.length; jk++) {
                                    //console.log("key before translation->" + keys[jk]);
                                    if ((keys[jk].indexOf("\\") > -1)) {
                                                let Attrs = (keys[jk] || '').trim().split("\\");

                                        for (let i = 0; i < Attrs.length; i++) {
                                            Attrs[i] = self.getKeyByValue(self._appliservice.dict, Attrs[i]);
                                            if (Attrs[i] === "PIN_Number")
                                                Attrs[i] = "Pin_Number";
                                        }
                                        keys[jk] = Attrs.join("\\");
                                    } else if ((keys[jk] || '').trim() != "") {
                                        keys[jk] = self.getKeyByValue(filtered, (keys[jk] || '').trim());
                                    }
                                    if ((keys[jk] || '').trim() === "Catégorie de taxation")
                                        keys[jk] = "Metering_Category";
                                } */
                            /* if (!(selectedSubClassNames.indexOf(classname) > -1))
                                continue; */
                            while ((Lines[i] || '').trim() != "") {
                                let objdata: any = {};
                                dataValues = (Lines[i] || '').split('\t');
                                for (let jkl = 0; jkl < keys.length; jkl++) {
                                    let key = (keys[jkl] || '').trim();
                                    let value = (dataValues[jkl] || '').trim();
                                    objdata[key] = value;
                                }

                                objectdata.push(objdata);
                                i++;
                                if (i >= Lines.length) {
                                    break;
                                }
                            }
                            self.finalData[classname] = objectdata;
                        }

                        let subclassNames = Object.keys(self.finalData);
                        let subclass: Array<Object> = [];
                        for (let key = 0; key < subclassNames.length; key++) {
                            if (subclassNames[key] === "Subscriber") {
                                subclass.push({ 'name': subclassNames[key], 'checked': true });
                            } else {
                                subclass.push({ 'name': subclassNames[key], 'checked': false });
                            }

                        }
                        //subclass.shift();
                        let selectedSubClassNames = [];

                        self._selectExportService.confirm('confirm-class-import', subclass).then(() => {

                            for (let j = 0; j < self._selectExportService.subclassList.length; j++) {
                                if (self._selectExportService.subclassList[j]['checked'] === true) {
                                    selectedSubClassNames.push(self._selectExportService.subclassList[j]['name']);
                                }
                            }
                            /* console.log("before...");
                            console.log(self.finalData); */
                            self.finalData = self.filterJson(self.finalData, selectedSubClassNames);
                            let selectedClassNames = Object.keys(self.finalData);
                            let processedNumber = 0;
                            let reqData;
                            let transClassName;
                            //selectedClassNames.splice(0, 1);

                            observableFrom(selectedClassNames).pipe(concatMap((className) => {
                                /* console.log("pratik"); */
                                let classObj;

                                self._translate.get(className)
                                    .subscribe((translatedString) => {
                                        transClassName = translatedString;
                                    })
                                self.logArrayImport.push("Processing " + className);
                                /* console.log(className); */
                                if (className === self.node.name)
                                    classObj = self.node['structure'];
                                else
                                    classObj = self.node['structure']['subClasses'][className];
                                //filtered = self.filterJson(self._appliservice.dict, Object.keys(classObj['attributes']));
                                self.allAttrs = [];
                                self.fetchAllAttributes(classObj['attributes'])
                                filtered = self.filterJson(self._appliservice.dict, self.allAttrs);
                                reqData = self.finalData[className];
                                let transValue;
                                processedNumber = 0;
                               // transClassName = className;
                                return observableFrom(reqData).pipe(
                                    concatMap((data) => {
                                        let objdata: any = {};
                                        let keys = Object.keys(data);
                                        for (let jkl = 0; jkl < keys.length; jkl++) {
                                            let key = keys[jkl];
                                            let value = data[key];
                                            if(className === "Subscriber_Keyboard")
                                                key = key.replace(/^"(.*)"$/, '$1');
                                            //filtered = self.filterJson(self._appliservice.dict, Object.keys(classObj['attributes']));
                                            //key = self.getKeyByValue(filtered, key);
                                            if (sFileExtension === "txt") {
                                                //console.log("key before translation->" + keys[jk]);
                                                if ((key.indexOf("\\") > -1)) {
                                                    let Attrs = key.split("\\");

                                                    for (let i = 0; i < Attrs.length; i++) {
                                                        Attrs[i] = self.getKeyByValue(filtered, Attrs[i]);
                                                       /*  if (Attrs[i] === "PIN_Number")
                                                            Attrs[i] = "Pin_Number"; */
                                                        switch (Attrs[i]) {
                                                            case "Prioridade implícita": {
                                                                Attrs[i]  = "Implicit_Prio";
                                                                break;
                                                            }
                                                            /* case "\"Mnemo (Pocket,Mobile,4040,8&9)\"": {
                                                                Attrs[i]  = "Key_NOE_Mnemonic1";
                                                                break;
                                                            } */
                                                        }
                                                    }
                                                    key = Attrs.join("\\");
                                                } else if (key != "") {
                                                    key = self.getKeyByValue(filtered, key);
                                                }
                                                switch (key) {
                                                    case "Type de Profil": {
                                                        key = "Profile_Type";
                                                        break;
                                                    }
                                                }
                                                /* if (key === "Catégorie de taxation")
                                                    key = "Metering_Category"; */
                                            }
                                           /*  console.log("key as->" + key); */
                                            let a = 0;

                                            if (classObj['attributes'][key] != undefined) {
                                                transValue = value;
                                                if (classObj['attributes'][key]['create'] === false && className != "Subscriber")
                                                    a = 1;
                                                if (classObj['attributes'][key]['type']['name'] === "Enumerated" && /* value.trim() != "Default" && */ value != "") { // getting keys from enumerated attributes
                                                    let dictFilter = self.filterJson(self._appliservice.dict, classObj['attributes'][key]['type']['values']);
                                                    transValue = self.getKeyByValue(dictFilter, value);
                                                    //transValue = self.getKeyByValue(self._appliservice.dict, dataValues[jkl].trim());
                                                }
                                            } else {
                                                transValue = value;  // this will executed in case of the sequence attribute where it throws undefined for in IF condition
                                            }
                                            if (a != 1) {
                                                if ((key.indexOf("\\") > -1)) {
                                                    let Attrs = key.split("\\");
                                                    let obj: any = {};
                                                    let temp;
                                                    let MainAttr = Attrs[0];

                                                    /* To get the last last attribute name in sequence so the we can check whether this is the sequence attribute
                                                    and get the translation for the value */
                                                    /* console.log("1"); */
                                                    let a = classObj['attributes'];
                                                    for (let i = 0; i < Attrs.length - 1; i++) {
                                                        temp = a[Attrs[i]]['type']['sequence'];
                                                        a = temp;
                                                    }
                                                   /*  console.log("2");
                                                    console.log(a);
                                                    console.log(a[Attrs[Attrs.length - 1]]);
                                                    console.log(Attrs[Attrs.length - 1]);
                                                    console.log(Attrs.length - 1); */
                                                    if (a[Attrs[Attrs.length - 1]]['type']['name'] === "Enumerated" && transValue != "") {
                                                        let dictFilter = self.filterJson(self._appliservice.dict, a[Attrs[Attrs.length - 1]]['type']['values']);
                                                        transValue = self.getKeyByValue(dictFilter, transValue);
                                                    }
                                                    /* Above we got the translation in case of enumerated attribute */
                                                   /*  console.log("3"); */
                                                    if (classObj['attributes'][MainAttr]['type']['name'] === "Sequence") {
                                                        for (let i = Attrs.length - 1; i > 0; i--) {

                                                            temp = transValue;

                                                            obj[Attrs[i]] = temp;
                                                            transValue = obj;
                                                            if (i != 1) {
                                                                obj = {};
                                                            }
                                                        }
                                                        /* console.log("obj value->");
                                                        console.log(obj); */
                                                        //merge with the main objdata --- need to change this code with the merge function available in the file.
                                                        if (objdata[Attrs[0]] === undefined) {
                                                            objdata[Attrs[0]] = obj;
                                                        } else {
                                                            if (objdata[Attrs[0]][Attrs[1]] === undefined) {
                                                                objdata[Attrs[0]][Attrs[1]] = obj[Attrs[1]];
                                                            } else {
                                                                objdata[Attrs[0]][Attrs[1]][Attrs[2]] = obj[Attrs[1]][Attrs[2]];
                                                            }
                                                        }
                                                        //till here replce with merge function
                                                    }

                                                } else {
                                                    objdata[key] = transValue;
                                                }
                                            } //end of a!-1
                                        } // end of keys loop

                                        if (className === "Subscriber") {
                                            let idname = self.node.structure['id'];
                                            let operation = objdata["ACTION"];
                                            let usertobeCreated = objdata[idname];
                                            let entitynumber = objdata["Entity_Number"];
                                            self.logArrayImport.push("Processing " + className + "-->" + usertobeCreated);
                                            delete objdata[""];
                                            delete objdata["ACTION"];
                                            delete objdata["Subscriber"];

                                            let path = self.node.getPath() + "/" + objdata[idname];
                                            let dirNumberSaved = objdata[idname];
                                            delete objdata[idname];

                                            let extdata = objdata;
                                            keys = Object.keys(extdata);
                                            if (operation === undefined || operation === "") {
                                                operation = "+";
                                                if (existingNodes instanceof Array) {
                                                    for (let number = 0; number < existingNodes.length; number++) {
                                                        if (existingNodes[number]["Directory_Number"] === usertobeCreated) {

                                                            keys.forEach(element => {
                                                                if (existingNodes[number][element] === undefined)
                                                                    delete extdata[element];
                                                                else if ("" + existingNodes[number][element] === extdata[element])
                                                                    delete extdata[element];
                                                            });
                                                            /* if ("" + existingNodes[number]["Entity_Number"] === entitynumber)
                                                                delete extdata["Entity_Number"]; */
                                                            operation = "#";
                                                            delete extdata['Associated_Station_Directory_Number'];
                                                            if (extdata['PIN'] != undefined)
                                                                if (extdata['PIN']['Pin_Number'] != undefined) {
                                                                    if (extdata['PIN']['Pin_Number'].trim() === "")
                                                                        delete extdata['PIN'];
                                                                }
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                            if (operation === "+") {
                                                keys.forEach(element => {
                                                    if (extdata[element] === "")
                                                        delete extdata[element];
                                                    if (extdata[element] instanceof Object) {
                                                        self.parseObject(extdata[element]);
                                                        if (self.isJsonEmpty === true) {
                                                            delete extdata[element];
                                                        }
                                                        self.isJsonEmpty = true;

                                                    }

                                                });
                                            }

                                            return self._oxeModel.setDataWithUrl(path, extdata, operation).pipe(
                                                catchError((error) => {
                                                    processedNumber++;
                                                    self.valueChange.emit("processing " + transClassName + " " + Math.round((processedNumber * 100) / reqData.length) + "%");
                                                    self._logger.storeLogArray("Error", "processing of Subscriber " + usertobeCreated + " Failed");
                                                    //self._logger.storeLogArray("Error", error);
                                                    self.logArrayImport.push("ERROR : " + "processing of Subscriber =>" + usertobeCreated + " Failed");
                                                    self.logArrayImport.push("ERROR : " + self._oxeModel.errorCode);
                                                    self.logArrayImport.push("ERROR : " + self._oxeModel.errorMsg);
                                                    self.logArrayImport.push("ERROR : " + self._oxeModel.errorDetailMsg + " For " + self._oxeModel.errorDetailTarget);
                                                    self._oxeModel.errorDetailMsg = "";
                                                    self._oxeModel.errorDetailTarget = "";
                                                    //console.log(error);
                                                    //console.log("user failed-->" + dirNumberSaved);

                                                    //self._oxeModel.setLoader(false);
                                                    return observableOf();
                                                })
                                            )

                                        } else { // is classname is not subscriber
                                            let data = objdata;
                                            let primAttr = self.node['structure']['subClasses'][className].id;
                                            let obsret;
                                            let dirnumber = "";
                                            if (data['Subscriber'] === undefined) {
                                                dirnumber = data['Users'];
                                            } else {
                                                dirnumber = data['Subscriber'];
                                            }
                                            let firstclass = selectedClassNames[0];
                                            keys = Object.keys(data);
                                            keys.forEach(element => {
                                                if (data[element] === "")
                                                    delete data[element];
                                                if (data[element] instanceof Object) {
                                                    self.parseObject(data[element]);
                                                    if (self.isJsonEmpty === true) {
                                                        delete data[element];
                                                    }
                                                    self.isJsonEmpty = true;

                                                }

                                            });

                                            let url = self.node.getPath().split(firstclass)[0] + firstclass + "/" + dirnumber + "/" + className + "/" + data[primAttr];
                                            let mainAttrValue = data[primAttr];
                                            self.logArrayImport.push("processing of " + className + " for \"" + firstclass + "/" + dirnumber + "/" + className + "/" + mainAttrValue + "\"");
                                            delete data[""];
                                            delete data['ACTION'];
                                            delete data['Subscriber'];
                                            delete data['Node'];
                                            delete data['Users'];
                                            delete data[primAttr];
                                            if (className === "Subscriber_Keyboard")
                                                delete data['Key_Id'];

                                            if (Object.keys(data).length === 0)
                                                return observableOf();

                                            if (self.node['structure']['subClasses'][className]['create'] === true) {
                                                obsret = self._oxeModel.setDataWithUrl(url, data, "+");

                                            } else {

                                                obsret = self._oxeModel.setDataWithUrl(url, data, "#");

                                            }
                                            return obsret.pipe(
                                                catchError((error) => {
                                                    /* console.log(error); */
                                                    processedNumber++;
                                                    self.valueChange.emit("processing " + transClassName + " " + Math.round((processedNumber * 100) / reqData.length) + "%");
                                                    self.logArrayImport.push("ERROR : "+"processing of " + transClassName + " failed for \"" + firstclass + "/" + dirnumber + "/" + className + "/" + mainAttrValue + "\"");
                                                    self.logArrayImport.push("ERROR : "+self._oxeModel.errorCode);
                                                    self.logArrayImport.push("ERROR : "+self._oxeModel.errorDetailMsg);
                                                    //console.log("occured error=>"+error);
                                                    //self._oxeModel.setLoader(false);
                                                    return observableOf();
                                                })
                                            )

                                        }

                                    })) //end of concat map

                            }))
                                .subscribe((data) => {
                                    self.valueChange.emit("processing " /* + transClassName + " " + Math.round((datasaved * 100) / classData.length) + "%" */);
                                    processedNumber++;
                                    self.valueChange.emit("processing " + transClassName + " " + Math.round((processedNumber * 100) / reqData.length) + "%");
                                },
                                    (error) => {
                                        console.log(error);
                                    },
                                    () => {

                                        self.finalData = {};
                                        objData = {};
                                        self.valueChange.emit("");
                                        self.logArrayImport.push("Finished Import ....");
                                        self._oxeModel.retrieveSubNodes(self.node)
                                            .subscribe((nodes) => {
                                                if (!self.node.isExpanded) {
                                                    self.node.isExpanded = true;
                                                    self.cd.markForCheck();
                                                    if (true) {
                                                        self._oxeModel.selectNode(self.node);
                                                    }
                                                } else {
                                                    if (self.node.isClassNode && !self.node.isOneInstance) {
                                                        self._oxeModel.removeUnchangedSubNodes(self.node, false);
                                                    }
                                                    self.node.isExpanded = false;

                                                }
                                                self._oxeModel.setLoader(false);
                                                let logstr = self.logArrayImport.join('\n');
                                                let blobLog = new Blob([logstr], {
                                                    type: 'text/plain'
                                                });
                                                let fileName = 'OXE-WBM-MassProImport-' + moment().format('DD-MM-YYYY--H-mm-ss') + '.log';
                                                let Lurl = window.URL.createObjectURL(blobLog);
                                                let Le = document.createElement('a');
                                                Le.setAttribute('href', Lurl);
                                                Le.setAttribute('download', fileName);

                                                document.body.appendChild(Le);
                                                Le.click();
                                                document.body.removeChild(Le);
                                                self._oxeModel.setLoader(false);
                                                self.logArrayImport = [];
                                                self.allAttrs = [];
                                                //console.log("completed everything");
                                            })
                                    })
                        })
                            .catch(() => {
                                self.valueChange.emit("canceling...");
                                self.valueChange.emit("");
                                self._oxeModel.setLoader(false);
                            });

                    })
            }
        }


        catch (e) {
            self.valueChange.emit("canceling...");
            self.valueChange.emit("");
            self._oxeModel.setLoader(false);
        }
        reader.readAsText(evt.target.files[0], "UTF-8");

    }

    fetchAllAttributes(attributes) {
        console.log("in fetchattributes...");
        for (let key in attributes) {
            let val = attributes[key];
            if (val['type']['name'] === "Sequence") {
                this.allAttrs.push(key);
                this.fetchAllAttributes(val['type']['sequence']);
            } else {
                    this.allAttrs.push(key);
            }
        }

    }

    parseObject(object1) {
        for (var key in object1) {
            //console.log("key: " + key + ", value: " + object1[key]);
            if (object1[key] != "" && !(object1[key] instanceof Object))
                this.isJsonEmpty = false;
            else if (object1[key] instanceof Object) {
                this.parseObject(object1[key]);
            }
        }
    }

    onSubmit(form: FormGroup) {
        // Even when "save" button is hidden, when the Return key is pressed, the form is submitted
        if (form.valid && this.node.isValid && (this.node.isLocal || this.node.isAttributesModified)) {
            console.log('Form Values on Submit:', this.node.name);
            // Only use getRawValue for broadcast/global behaviour nodes
            const isBroadcastNode = this.node.name === '1';
            const gbGroup = form.get('Global_Behaviour') as FormGroup || null;
            const hasGlobalBehaviour = !!(gbGroup && (gbGroup.get('Outgoing') || gbGroup.get('Incoming')));
            console.log('hasGlobalBehaviour', hasGlobalBehaviour, 'Global_Behaviour group:', gbGroup ? gbGroup.getRawValue() : null);
            let modifiedNodes = this.getModifiedParentNodes(this.node);
            if (modifiedNodes.length > 0) {
                this._dialogService.confirm('confirm-save-parents')
                    .then(() => {
                        modifiedNodes.push(this.node);
                        let numberOfNodeSaved = 0;
                        let workingNode: INode;
                        observableFrom(modifiedNodes).pipe(
                            concatMap(node => {
                                workingNode = node;
                                if (isBroadcastNode && hasGlobalBehaviour) {
                                    // include disabled/server values too
                                    const payload = (form as any).getRawValue ? (form as any).getRawValue() : form.value;
                                    console.log('Payload being sent (with Global_Behaviour):', payload);
                                    return this._oxeModel.setData(node, payload);
                                } else {
                                    return this._oxeModel.setData(node, node.getLocalData(node.attributes));
                                }
                            }))
                            .subscribe(
                            () => {
                                numberOfNodeSaved++;
                                this._logger.storeLogArray('Info', this.translatedvalues['creation-of'] + ' ' + this.node.parent.name + ' ' + this.node.name + ' ' + this.translatedvalues['successfull']);
                            },
                            (error) => {
                                if (numberOfNodeSaved > 0) {
                                    this._translate.get('save-success')
                                        .subscribe((translatedString) => {
                                            this.notifySuccess(translatedString + '<br>' + numberOfNodeSaved + '/' + modifiedNodes.length);
                                        });
                                }
                                this._oxeModel.selectNode(workingNode);
                            },
                            () => {
                                this._translate.get('save-success')
                                    .subscribe((translatedString) => {
                                        this.notifySuccess(translatedString + '<br>' + numberOfNodeSaved + '/' + modifiedNodes.length);
                                    });
                            }
                            );
                    })
                    .catch(() => { });
            } else {
                if (isBroadcastNode && hasGlobalBehaviour) {
                    const payload = (form as any).getRawValue ? (form as any).getRawValue() : form.value;
                    console.log('Payload being sent (with Global_Behaviour):', payload);
                    this._oxeModel.setData(this.node, payload)
                        .subscribe(() => {
                            if (this.numberOfNodes > 0) {
                                this.numberOfNodes--;
                            }
                            this.notifySuccess('saved');
                            if (this.node.isLocal) {
                                this._logger.storeLogArray('Info', this.translatedvalues['creation-of'] + ' ' + this.node.parent.name + ' '
                                    + this.node.name + ' ' + this.translatedvalues['successfull']);
                            } else {
                                this._logger.storeLogArray('Info', this.translatedvalues['updation-of'] + ' ' + this.node.parent.name + ' '
                                    + this.node.name + ' ' + this.translatedvalues['successfull']);
                            }
                            if (this._oxeModel.isProfiledUser(this.node)) {
                                this.node.parent.subNodes.splice(this.node.parent.subNodes.indexOf(this.node), 1);
                                this.node.parent.subNodesInitialLength--;
                                this._oxeModel.selectNode(this.node.parent);
                            }
                        },
                        (error) => {
                            let operationType;
                            if (this.node.isLocal) {
                                operationType = this.translatedvalues['creation-of'];
                            } else {
                                operationType = this.translatedvalues['updation-of'];
                            }
                            this._errorNotification.generateErrorNotification(error, operationType, ' ' + this.node.parent.name + ' ' + this.node.name + ' ' + this.translatedvalues['failed']);
                            if (!this.node.isLocal) {
                                this._oxeModel.retrieveData(this.node)
                                    .subscribe(() => {
                                        this.node.removeAttributesMarkedToDelete();
                                        this._oxeModel.filterAndSortDisplayedSubNode(this.node.parent);
                                        this._oxeModel.selectNode(this.node);
                                    });
                            }
                        });
                } else {
                    this._oxeModel.setData(this.node, this.node.getLocalData(this.node.attributes))
                        .subscribe(() => {
                            if (this.numberOfNodes > 0) {
                                this.numberOfNodes--;
                            }
                            this.notifySuccess('saved');
                            if (this.node.isLocal) {
                                this._logger.storeLogArray('Info', this.translatedvalues['creation-of'] + ' ' + this.node.parent.name + ' '
                                    + this.node.name + ' ' + this.translatedvalues['successfull']);
                            } else {
                                this._logger.storeLogArray('Info', this.translatedvalues['updation-of'] + ' ' + this.node.parent.name + ' '
                                    + this.node.name + ' ' + this.translatedvalues['successfull']);
                            }
                            if (this._oxeModel.isProfiledUser(this.node)) {
                                this.node.parent.subNodes.splice(this.node.parent.subNodes.indexOf(this.node), 1);
                                this.node.parent.subNodesInitialLength--;
                                this._oxeModel.selectNode(this.node.parent);
                            }
                        },
                        (error) => {
                            let operationType;
                            if (this.node.isLocal) {
                                operationType = this.translatedvalues['creation-of'];
                            } else {
                                operationType = this.translatedvalues['updation-of'];
                            }
                            this._errorNotification.generateErrorNotification(error, operationType, ' ' + this.node.parent.name + ' ' + this.node.name + ' ' + this.translatedvalues['failed']);
                            if (!this.node.isLocal) {
                                this._oxeModel.retrieveData(this.node)
                                    .subscribe(() => {
                                        this.node.removeAttributesMarkedToDelete();
                                        this._oxeModel.filterAndSortDisplayedSubNode(this.node.parent);
                                        this._oxeModel.selectNode(this.node);
                                    });
                            }
                        });
                }
            }
        }
    }

    onReset() {
        if (this.node.isLocal) {
            this._deleteNode();
        } else {
            this.node.removeLocalAttributes();
            this.node.clearLocalChanges();
            this.node.evaluateAttributesUsedWhen();
            this.node.evaluateSubNodesUsedWhen();
            this.updateFormControls();
            this.notifySuccess('canceled');
        }
        this.numberOfNodes--;
    }

    onCreate() {
        let parentNodeForCreation: INode;
        if (this.node.isObjectNode) {
            //we create the new object under the parent class
            parentNodeForCreation = this.node.parent;
        } else {
            //we create the new object under the currrent class node
            parentNodeForCreation = this.node;
        }
        const createdNode = this._oxeModel.findAndUpdateObjectNode(parentNodeForCreation, {}, undefined, true);
        if (createdNode) {
            this._oxeModel.selectNode(createdNode);
            this._oxeModel.filterAndSortDisplayedSubNode(parentNodeForCreation);
            parentNodeForCreation.filterApplied(); //in order to move tree view to first page
            if (parentNodeForCreation.name === "Subscriber") {
                this._oxeModel.setFreeNumber(this.numberOfNodes).
                    subscribe((data) => {
                        let objectdata: any = {
                            "Directory_Number": data
                        };
                        this.node.updateAttributesWithLocal(objectdata, this._appliservice.dict);
                        this._oxeModel.selectNode(this.node);
                    })
            }
        }
        this.numberOfNodes++;
    }

    onDelete() {
        let idname = this.node.structure['id'];
        this._translate.get(idname).subscribe((translatedString) => { idname = translatedString; });
        const details = idname + ': ' + this.node.name;
        this._dialogService.confirm('confirm-remove', '', details)
            .then(() => this._deleteNode())
            .catch(() => { });
    }

    private _deleteNode() {
        let deletedNode = this.node;

        this._oxeModel.deleteData(deletedNode)
            .subscribe(() => {
                if (!this.node.isLocal) {
                    this._logger.storeLogArray('Info', this.translatedvalues['deletion-of'] + ' ' + this.node.parent.name + ' '
                        + this.node.name + ' ' + this.translatedvalues['successfull']);
                }
                this.notifySuccess(this.node.isLocal ? 'canceled' : 'deleted');
                //display parent node
                this._oxeModel.selectNode(deletedNode.parent);
                this._oxeModel.filterAndSortDisplayedSubNode(deletedNode.parent);
            });

    }

    onAction(actionName: string) {
        this._logger.debug('ConfigDetailComponent', 'onAction:' + actionName);
        const action = this.node.getActionByName(actionName);
        if (!action) {
            return;
        }

        if (!action.info) {
            //display a dialog to confirm a simple action (without info params)
            let idname = this.node.structure['id'];
            this._translate.get(idname).subscribe((translatedString) => { idname = translatedString; });
            const details = idname + ': ' + this.node.name;
            this._dialogService.confirm('confirm-action', actionName, details)
                .then(() => this._doAction(action))
                .catch(() => { });
        } else {
            //display a form template in order to enter the info params of the action
            this.actionWithInfo = action;
        }
    }

    onSubmitAction(infoData) {
        this._doAction(this.actionWithInfo, infoData);
    }

    onCancelAction() {
        this.actionWithInfo = undefined;
    }

    onGroupClicked(index: number) {
        try {
            this.selectedGroupId = index;
            this.updateFormControls();
        } catch (err) {
            this._oxeModel.selectNode(this.node.parent);
            throw err;
        }
    }

    onExport(fileName: string) {
        var self = this;
        let subClassNames: Array<Object> = [];
        this.selectedSubClassNames = [];
        this.logarray = [];
        // if (!this.node.subNodes) {
        let nodes: Array<INode> = [];
        let nodeStructure = this.node['structure'];
        // must have a structure
        if (nodeStructure && nodeStructure.hasOwnProperty('subClasses')) {
            for (let key in nodeStructure['subClasses']) {
                if (key != undefined)
                    //   this._translate.get(key).subscribe((translatedString) => { key = translatedString; });
                    subClassNames.push({ 'name': key, 'checked': false });
            }
        }

        //  }
        let nodeName = [];
        let mainClassName = { 'name': this.node.name, 'checked': true };
        subClassNames.unshift(mainClassName);
        this.url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + self.node;
        this._dialogExportService.confirm('are-you-sure-to-export')
            .then(() => {
                this._selectExportService.confirm('Please select the classes to export', subClassNames).then(() => {
                    for (let j = 0; j < this._selectExportService.subclassList.length; j++) {
                        if (this._selectExportService.subclassList[j]['checked'] === true) {
                            this.selectedSubClassNames.push(this._selectExportService.subclassList[j]['name'])
                        }
                    }

                    if (this._dialogExportService.csvCheck) {
                        this.onExportFile('txt');
                        this._dialogExportService.csvCheck = false;
                    } if (this._dialogExportService.prgCheck) {
                        this.onExportFile('prg');
                        this._dialogExportService.prgCheck = false;
                    }
                })
                    .catch(() => { });
            }
            )
            .catch(() => { });
    }

    onExportFile(format: string) {

        let lines = [];
        let dataLines = [];
        this.seqHeaderArray = [];
        this.seqValueArray = [];
        let attrSubArr = [];
        this._oxeModel.setLoader(true);

    // compute once whether main class should be exported
    const exportMain = !(this.selectedSubClassNames && this.selectedSubClassNames.length > 0 && this.selectedSubClassNames.indexOf(this.node.name) === -1);

        this.http.get(this.url).pipe(map((data: any) => data)).subscribe(
            data => {
                if (data.length == 0) {
                    // this._logger.storeLogArray("Error", "No user entries are found");
                    // this.logarray.push("No User Entries are found");
                    this._logger.storeLogArray("Info", "Begin Of Export");
                    // Only include main-class heading and ACTION when main class is selected for export
                    const exportMain = !(this.selectedSubClassNames && this.selectedSubClassNames.length > 0 && this.selectedSubClassNames.indexOf(this.node.name) === -1);
                    if (exportMain) {
                        this.attrs.push(this.node.name + '\n');
                        this.attrs.push("ACTION");
                    }
                    let attrArr = this.fetchAttributes(this.node['structure']['attributes'], format);
                    this.attrs.push(attrArr.join('\t'));
                    this.attrs.push('\n');

                    for (let i = 0; i < this.selectedSubClassNames.length; i++) {
                        if (this.selectedSubClassNames[i] != 'Subscriber') {
                            attrSubArr.push(this.selectedSubClassNames[i].toString() + '\n');
                            //attrSubArr.push("ACTION");
                           // attrSubArr.push("Subscriber");
                            attrSubArr.push(this.fetchAttributes(
                                this.node['structure']['subClasses']
                                [this.selectedSubClassNames[i].toString()]
                                ['attributes'], format).join('\t')
                            );
                            this.attrs.push(attrSubArr.join('\t'));
                            this.attrs.push('\n');
                            attrSubArr = [];
                        }
                    }
                    let str: string = this.attrs.join('\t');
                    this.attrs = [];
                    str = str.replace(/\n\t/g, '\n');
                    let blobObject = new Blob([str], {
                        type: 'text/plain'
                    });
                    let fileName = 'OXEWBM_MassProExport_' + moment().format('DD-MM-YYYY--H-mm-ss') + '.' + format;
                    this._logger.storeLogArray("Info", "End Of Export");
                    let url = window.URL.createObjectURL(blobObject);
                    let e = document.createElement('a');
                    e.setAttribute('href', url);
                    e.setAttribute('download', fileName);

                    document.body.appendChild(e);
                    e.click();
                    document.body.removeChild(e);
                    this._oxeModel.setLoader(false);
                    return;
                }
                this._logger.storeLogArray("Info", "Begin Of Export");
                this.logarray.push("Begin Of Export");
                //   this.valueChange.emit("Exporting Users...");
                this._logger.storeLogArray("Info", "Exporting Users...");
                this.logarray.push("Exporting Users...");

                // Only include main-class heading and ACTION when main class is selected for export
                const exportMain = !(this.selectedSubClassNames && this.selectedSubClassNames.length > 0 && this.selectedSubClassNames.indexOf(this.node.name) === -1);
                if (exportMain) {
                    lines.push(this.node.name + '\n');
                    lines.push("ACTION");
                }
                /* lines.push("Subscriber"); */

                this.newData = data;
                // if user selected subclasses and did not select the main class, skip exporting the main class
                let arr = this.newData && this.newData.length > 0 ? Object.keys(this.newData[0]) : [];

                if (exportMain) {
                    for (let i = 0; i < arr.length; i++) {
                    let idname = arr[i];
                    let seqName;
                    if (format === 'txt') {
                        if (this.node.getAttributeByName(idname).structure['type']['sequence'] != undefined) {
                            let seqArray = this.node.getAttributeByName(idname).structure['type']['sequence'];
                            this.recursiveHeader(seqArray, idname, format);
                            for (let k = 0; k < this.seqHeaderArray.length; k++) {
                                lines.push(this.seqHeaderArray[k]);
                            }
                            this.seqHeaderArray = [];
                        } else {
                            this._translate.get(idname.toString()).subscribe((translatedString) => { idname = translatedString; });
                            lines.push(idname);
                        }
                    } else {
                        if (this.node.getAttributeByName(idname).structure['type']['sequence'] != undefined) {
                            let seqArray = this.node.getAttributeByName(idname).structure['type']['sequence'];
                            this.recursiveHeader(seqArray, idname, format);
                            for (let k = 0; k < this.seqHeaderArray.length; k++) {
                                lines.push(this.seqHeaderArray[k]);
                            }
                            this.seqHeaderArray = [];
                        } else {
                            lines.push(idname);
                        }
                    }
                    }
                    lines.push('\n');


                    let transValue;
                    for (let i = 0; i < this.newData.length; i++) {
                        dataLines.push(" ");

                        // dataLines.push(this.newData[i]['Directory_Number']);
                        for (let j = 0; j < arr.length; j++) {
                            let idname = arr[j];
                            if (this.node.getAttributeByName(idname).structure['type']['sequence'] != undefined) {

                                let seqArray = this.node.getAttributeByName(idname).structure['type']['sequence'];
                                this.recursiveValue(seqArray, this.newData[i], idname, format);
                                for (let k = 0; k < this.seqValueArray.length; k++) {
                                    dataLines.push(this.seqValueArray[k]);
                                }
                                this.seqValueArray = [];

                            } else {
                                transValue = this.newData[i][arr[j]];
                                if (transValue != '' && transValue != undefined && isNaN(transValue)) {
                                    this._translate.get(transValue).subscribe((translatedString) => {
                                        transValue = translatedString;
                                        dataLines.push(transValue);
                                    })
                                } else {
                                    dataLines.push(transValue);
                                }
                            }
                        }
                        dataLines.push('\n');
                    }
                    lines.push(dataLines.join('\t'));
                } // end if exportMain
                // lines.push('\n');
                let dirNumber: Array<Object> = [];
                let subClassData = [];
                let isHeaderUpdated: boolean = false;
                let observableArray = [];
                let className = "";
                for (let dNum = 0; dNum < this.newData.length; dNum++) {
                    dirNumber.push(this.newData[dNum]['Directory_Number'])
                }
                if (this.selectedSubClassNames.length > 0) {

                    // iterate all selected subclasses and skip the main class (this.node.name)
                    for (let jk = 0; jk < this.selectedSubClassNames.length; jk++) {
                        const subclassName = this.selectedSubClassNames[jk];
                        if (!subclassName || subclassName === this.node.name) continue;

                        dirNumber.forEach(dir => {
                            const newURL = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/'
                                + this.node + '/' + dir + '/' + subclassName;
                            observableArray.push(this.http.get(newURL, { observe: 'response' }).pipe(
                                catchError((error) => {
                                    this.logarray.push(error);
                                    return observableOf(new HttpResponse<any[]>({ body: [] })); // Fallback response
                                }))
                            );
                        });
                    }
                }

                observableForkJoin(observableArray)

                   .subscribe((subData) => {

    subData.forEach((resp: HttpResponse<any[]>) => {

        let num = "";
        let self = this;

        // ✅ Correct way to access body and URL
        const newData = resp.body || [];
        const fullUrl = resp.url || '';

        if (newData.length > 0 && fullUrl) {

            // find 'Subscriber/' safely
            const idx = fullUrl.indexOf('Subscriber/');
            if (idx !== -1) {

                // ✅ substring now safe
                const urlstring = fullUrl.substring(idx + 11); // 11 = length of 'Subscriber/'
                const dNumber = urlstring.split('/');
                num = dNumber[0];
                let urlClassName = dNumber[1];

                this._translate.get(urlClassName).subscribe(translatedString => {
                    urlClassName = translatedString;
                });

                // ======== Rest of your logic ========
                let arr: string[] = [];
                if (newData.length > 0) {
                    arr = Object.keys(newData[0]);

                    if (className === '') {
                        subClassData.push('\n');
                        subClassData.push(urlClassName + '\n');
                        const str = 'Exporting ' + urlClassName + ' ...';
                        this._logger.storeLogArray('Info', str);
                        this.logarray.push(str);

                        isHeaderUpdated = false;
                        subClassData.push('ACTION');
                        subClassData.push('Subscriber');

                        for (let i = 0; i < arr.length; i++) {
                            let idname = arr[i];
                            if (this.node.structure['subClasses'] &&
                                this.node.structure['subClasses'][urlClassName] &&
                                this.node.structure['subClasses'][urlClassName]['attributes'][idname]['type']['name'] === 'sequence') {

                                const seqArray = this.node.getAttributeByName(idname).structure['type']['sequence'];
                                this.recursiveHeader(seqArray, idname, format);
                                for (let k = 0; k < this.seqHeaderArray.length; k++) {
                                    subClassData.push(this.seqHeaderArray[k]);
                                }
                                this.seqHeaderArray = [];
                            } else {
                                this._translate.get(idname).subscribe(translatedString => {
                                    idname = translatedString;
                                });
                                subClassData.push(idname);
                            }
                        }

                        subClassData.push('\n');
                        className = urlClassName;

                    } else if (className !== urlClassName) {
                        subClassData.push('\n');
                        subClassData.push(urlClassName + '\n');
                        const str = 'Exporting ' + urlClassName + ' ...';
                        self.valueChange.emit(str);
                        this._logger.storeLogArray('Info', str);
                        this.logarray.push(str);

                        isHeaderUpdated = false;
                        subClassData.push('ACTION');
                        subClassData.push('Subscriber');

                        for (let i = 0; i < arr.length; i++) {
                            let idname = arr[i];
                            if (this.node.structure['subClasses'] &&
                                this.node.structure['subClasses'][urlClassName] &&
                                this.node.structure['subClasses'][urlClassName]['attributes'][idname]['type']['name'] === 'sequence') {

                                const seqArray = this.node.getAttributeByName(idname).structure['type']['sequence'];
                                this.recursiveHeader(seqArray, idname, format);
                                for (let k = 0; k < this.seqHeaderArray.length; k++) {
                                    subClassData.push(this.seqHeaderArray[k]);
                                }
                                this.seqHeaderArray = [];
                            } else {
                                this._translate.get(idname).subscribe(translatedString => {
                                    idname = translatedString;
                                });
                                subClassData.push(idname);
                            }
                        }

                        subClassData.push('\n');
                        className = urlClassName;
                    }

                    // Export subclass rows
                    if (className === urlClassName) {
                        for (let i = 0; i < newData.length; i++) {
                            subClassData.push(' ');
                            subClassData.push(num);
                            for (let j = 0; j < arr.length; j++) {
                                if ((this.node.getAttributeByName(arr[j]) != null) &&
                                    this.node.getAttributeByName(arr[j]).structure['type']['sequence'] !== undefined) {

                                    const seqArray = this.node.getAttributeByName(arr[j]).structure['type']['sequence'];
                                    this.recursiveValue(seqArray, this.newData[i], arr[j], format);
                                    for (let k = 0; k < this.seqValueArray.length; k++) {
                                        dataLines.push(this.seqValueArray[k]);
                                    }
                                    this.seqValueArray = [];
                                } else {
                                    let transValue = newData[i][arr[j]];
                                    if (transValue !== '' && transValue !== undefined && isNaN(transValue)) {
                                        this._translate.get(transValue.toString()).subscribe(translatedString => {
                                            transValue = translatedString;
                                        });
                                    }
                                    subClassData.push(transValue);
                                }
                            }
                            subClassData.push('\n');
                        }
                    }
                }
            }
        }

    }); // end forEach

}, 
(error) => { /* handle error if needed */ },
() => {
    this.valueChange.emit('');
    this._oxeModel.setLoader(false);
    lines.push(subClassData.join('\t'));
    let str: string = lines.join('\t').replace(/\n\t/g, '\n');
    let blobObject = new Blob([str], { type: 'text/plain' });
    let fileName = 'OXEWBM_MassProExport_' + moment().format('DD-MM-YYYY--H-mm-ss') + '.' + format;
    this._logger.storeLogArray('Info', 'End Of Export');
    this.logarray.push('End Of Export');

    // create download
    const url = window.URL.createObjectURL(blobObject);
    const e = document.createElement('a');
    e.setAttribute('href', url);
    e.setAttribute('download', fileName);
    document.body.appendChild(e);
    e.click();
    document.body.removeChild(e);

    const logstr = this.logarray.join('\n');
    const blobLog = new Blob([logstr], { type: 'text/plain' });
    const Lurl = window.URL.createObjectURL(blobLog);
    const Le = document.createElement('a');
    Le.setAttribute('href', Lurl);
    Le.setAttribute('download', 'OXEWBM_MassProExport_' + moment().format('DD-MM-YYYY--H-mm-ss') + '.log');
    document.body.appendChild(Le);
    Le.click();
    document.body.removeChild(Le);
});




            },
            (error) => {
                this._oxeModel.setLoader(false);
                return observableOf([]);
            },
            () => {
            });
    }

    private fetchAttributes(attributes, format) {
        let attrs = [];
        for (let key in attributes) {
            if (!attributes[key]) continue;
            if (key === 'Implicit_Prio' || key === 'Timer_Keep_Alive' || key === '4059_IP') continue;

            let val = attributes[key];
            if (!val?.type) continue; 
            if (key != 'Implicit_Prio' && key != 'Timer_Keep_Alive' && key != "4059_IP") {
                if (val['type']['name'] === "Sequence") {  // handling of sequence inside sequence attributes.
                    for (let seqKey in val['type']['sequence']) {
                        let seqVal = val['type']['sequence'][seqKey];
                        if (!seqVal?.type) continue;
                        if (seqVal['type']['name'] === "Sequence") {
                            for (let seqKey2 in seqVal['type']['sequence']) { // handling of sequence inside sequence attributes.
                                let seqVal2 = seqVal['type']['sequence'][seqKey2];
                                if (!seqVal2) continue;
                                if (format === 'txt') {
                                    this._translate.get(key.toString()).subscribe((translatedString) => {
                                        key = translatedString;
                                    });
                                    this._translate.get(seqKey.toString()).subscribe((translatedString) => {
                                        seqKey = translatedString;
                                    });
                                    this._translate.get(seqKey2.toString()).subscribe((translatedString) => {
                                        seqKey2 = translatedString;
                                    });
                                }
                                attrs.push(key + "/" + seqKey + "/" + seqKey2);
                            }
                        } else {
                            if (format === 'txt') {
                               this._translate.get(key.toString()).subscribe((translatedString) => {
                                        key = translatedString;
                                    });
                                    this._translate.get(seqKey.toString()).subscribe((translatedString) => {
                                        seqKey = translatedString;
                                    });
                            }
                            attrs.push(key + "/" + seqKey);
                        }
                    }
                } else {
                    if (format === 'txt') {
                       this._translate.get(key.toString()).subscribe((translatedString) => {
                                        key = translatedString;
                                    });
                    }
                    attrs.push(key);
                }
            }
        }
        attrs.push('\n');
        return attrs;
    }

    private recursiveHeader(transValue, idname, format) {

        if (transValue != undefined) {
            let seqArray: any[] = Object.keys(transValue);

            for (let i = 0; i < seqArray.length; i++) {
                if (transValue[seqArray[i]].type != null && transValue[seqArray[i]].type.name === "Sequence") {
                    if (format === "txt") {
                        this._translate.get(idname).subscribe((translatedString) => { idname = translatedString; });
                    }
                    idname = idname + '\\' + seqArray[i];
                    this.recursiveHeader(transValue[seqArray[i]].type.sequence, idname, format);
                } else {
                    if (format === "txt") {
                        this._translate.get(seqArray[i]).subscribe((translatedString) => { seqArray[i] = translatedString; });
                        this._translate.get(idname).subscribe((translatedString) => { idname = translatedString; });
                        this.seqHeaderArray.push(idname + '\\' + seqArray[i]);
                    } else {
                        this.seqHeaderArray.push(idname + '\\' + seqArray[i]);
                    }

                }
            }

        }

    }

    private recursiveValue(transValue, newDataString, idname, format) {

        // defensive guards: transValue may be undefined, and newDataString or its nested properties
        // (eg. newDataString[idname]) may be undefined when an attribute is missing in the response.
        if (transValue != undefined) {
            let seqArray: any[] = Object.keys(transValue);

            for (let i = 0; i < seqArray.length; i++) {
                const seqKey = seqArray[i];
                // minimal guard: if parent object missing, push undefined to keep alignment and continue
                if (!newDataString || !newDataString[idname]) {
                    this.seqValueArray.push(undefined);
                    continue;
                }
                const seqNode = transValue[seqKey];

                // If the schema indicates a nested Sequence, recurse safely using the child data
                if (seqNode && seqNode.type != null && seqNode.type.name === "Sequence") {
                    const childData = (newDataString && newDataString[idname]) ? newDataString[idname] : undefined;
                    this.recursiveValue(seqNode.type.sequence, childData, seqKey, format);
                } else {
                    // Safely read the value: parentObj may be undefined if the server didn't send that attribute
                    const parentObj = (newDataString && newDataString[idname]) ? newDataString[idname] : undefined;
                    const value = parentObj ? parentObj[seqKey] : undefined;

                    if (value !== undefined && value !== null && value !== "") {
                        let str = value;
                        this._translate.get(str.toString()).subscribe((translatedString) => {
                            this.seqValueArray.push(translatedString);
                        });
                    } else {
                        // preserve column alignment by pushing the raw value (could be undefined/null/empty)
                        this.seqValueArray.push(value);
                    }
                }
            }

        }
    }


    private _doAction(action: IAction, infoData?: Object) {
        if (!action) {
            return;
        }
        //Do Oxe action
        this._oxeModel.action(this.node, action.getData(infoData)).pipe(
            //translate action text for notification popup
            mergeMap(() => this._translate.get(action.name)))
            .subscribe((translatedAction) => {
                this.notifySuccess(translatedAction + ' success');
                //refresh parent node and subnodes, and select parent node only for specific actions (such as 'forced_delete' or 'move' actions which delete/move nodes)
                if (action.name === 'FORCED_DELETE') {
                    this.node.parent.subNodes.splice(this.node.parent.subNodes.indexOf(this.node), 1);
                    this.node.parent.subNodesInitialLength--;
                    this._oxeModel.selectNode(this.node.parent);
                }
                else if (action.name.startsWith('Move')) {
                    this._oxeModel.retrieveData(this.node.parent).subscribe(() => this._oxeModel.selectNode(this.node.parent));
                } else {
                    this._oxeModel.retrieveData(this.node).subscribe(() => this._oxeModel.selectNode(this.node));
                }
                this.actionWithInfo = undefined;
            });
    }

    /*   public storeLog(msg: string) {
     let momentDate = moment();
      this.massProLogArray.unshift({date: momentDate.toDate(),message :msg,type: 'Info'});
      }

      logDownload() {
          console.log(this.massProLogArray);
           let blobObject = new Blob([this.massProLogArray.join('\t')], {
                      type: 'text/plain'
                  });

                  let fileName = 'OXE-WBM-' + moment().format('DD-MM-YYYY--H-mm-ss') + '.log';
                  let url = window.URL.createObjectURL(blobObject);

                  let e = document.createElement('a');
                  e.setAttribute('href', url);
                  e.setAttribute('download', fileName);
                  document.body.appendChild(e);
                  e.click();
                  document.body.removeChild(e);
                  this.massProLogArray.length = 0;
      } */

    /**
     * Generates a notification toast to informe of a sucessful operation
     *
     * @param {string} operationTypeMessage (operation being performed)
     *
     * @memberOf ConfigDetailComponent
     */
    private notifySuccess(operationTypeMessage: string) {
        this._translate.get(operationTypeMessage)
            .subscribe((translatedMessage) => {
                this._notification.html(
                    `<aside class="flex-container nowrap flex-align-center notification notification--success icon__svg">
                    <span class="flex-item-fluid pas">` + translatedMessage + `</span>
                </aside>`, NotificationType.Bare);
            });
    }
}
